import { useContext } from 'react'
import { DataContext } from '../context/DataContext'
import { numberParser } from '../helpers/numberParser'
import { useCmsAdapter } from './useCmsAdapter'
import {
  getOrderFormId,
  getPinflagApiKey,
  getPostalCode,
  getTotalPriceSLA,
  getPinflagPostalCode,
  parseDeliveryTime
} from '../helpers/utils'
import { ONLY_CHECKOUT, DIFFERENT_REGION_NAME } from '../constants/stores'
import { changedRegionName, normalizeRegionName, getFullAdress, setCitySelect, regionCode } from '../helpers/addressParser'
import { parseBusinessHoursVTEX } from '../helpers/filterPoints'

export const useVtex = () => {
  const {
    addressInfo,
    ecommerceInfo,
    setCartData,
    setEcommerceInfo,
    userInfo,
    setUserInfo,
    companyInfo,
    cartData,
    selectedServiceType,
    searchAddress,
    setPointsData,
    setCurrentStep,
    billingInfo
  } = useContext(DataContext)
  const { ignoreProfileDataVtex, getOrderFormVtex, setClientDataVtex, setShippingDataVtex, getWeightVtex } = useCmsAdapter()

  const setInitialInformationVtex = async (message) => {
    const {
      cms,
      orderFormId,
      items,
      totals,
      currentUrl,
      clientData,
      loggedIn,
      step
    } = message
    if (cms !== 'vtex' && cms !== 'vtex-io') return
    const pinflagApiKey = getPinflagApiKey()
    setEcommerceInfo(prevState => {
      return { ...prevState, cms, orderFormId, currentUrl, loggedIn }
    })
    if (!totals || !items.length) {
      removeIframeVTEX()
      return
    }
    if (clientData && loggedIn) {
      const names = `${clientData.firstName} ${clientData.lastName}`
      const phone = clientData.phone.length > 9 ? clientData.phone.slice(clientData.phone.length - 9) : clientData.phone
      setUserInfo(prevState => {
        return {
          ...prevState,
          email: clientData.email,
          names: names.includes('null') ? '' : names,
          phone,
          rut: clientData.document
        }
      })
    }

    const totalWeight = await getWeightVtex(items, pinflagApiKey)

    const lines = []
    let itemsCount = 0
    items.forEach(item => {
      lines.push({
        id: `${item.uniqueId}`,
        productName: item.name,
        productImage: item.imageUrl,
        quantity: item.quantity,
        lineTotal: numberParser((item.price / 100) * item.quantity)
      })
      itemsCount += item.quantity
    })
    setCartData(prevState => {
      return {
        ...prevState,
        lines,
        subtotal: totals.value / 100,
        total: totals.value / 100,
        itemsCount,
        totalWeight: totalWeight?.data
      }
    })
    setCurrentStep(step || 1)
    /* if (addressData?.street) {
      setAddressInfo(prevState => {
        return {
          ...prevState,
          userAddress: `${addressData.street} ${addressData.number}`,
          aditionalInfo: addressData.complement,
          region: addressData.state,
          district: addressData.neighborhood,
          deliveryType: addressData.addressType,
        }
      })
    } */
  }

  const iframeLoadedVtexIO = async () => {
    const orderFormId = getOrderFormId()
    const pinflagApiKey = getPinflagApiKey()
    if (!orderFormId || orderFormId === 'default-order-form' || !pinflagApiKey) return
    try {
      const response = await getOrderFormVtex(orderFormId, pinflagApiKey)
      const { loggedIn, items, totalizers, clientProfileData: clientData } = response.data
      const totals = totalizers[0]
      const cms = 'vtex-io'
      await setInitialInformationVtex({
        cms,
        orderFormId,
        items,
        totals,
        // currentUrl,
        clientData,
        loggedIn
      })
    } catch (error) {
      console.log('error', error)
    }
  }

  const saveUserInformationVtex = async (userData, billingData) => {
    const { cms, orderFormId } = ecommerceInfo
    if (cms !== 'vtex' && cms !== 'vtex-io') return

    try {
      if (!ecommerceInfo.loggedIn) {
        await ignoreProfileDataVtex(ecommerceInfo.orderFormId)
      }
    } catch (err) {
      console.log(err)
    }
    const firstname = userData.names.substring(0, userData.names.indexOf(' '))
    const lastname = userData.names.substring(userData.names.indexOf(' ') + 1)
    const userInformation = {
      email: userData.email,
      firstName: firstname,
      lastName: lastname,
      documentType: 'rutCHL',
      document: userData.rut,
      phone: userData.phone,
      isCorporate: false
    }
    if (billingData) {
      const billingInformation = {
        corporateDocument: billingData.corporateRut,
        corporateName: billingData.corporateName,
        corporatePhone: billingData.corporatePhone,
        isCorporate: true,
        tradeName: billingData.category,
        stateInscription: billingData.corporatePhone
      }
      Object.assign(userInformation, billingInformation)
    }
    await setClientDataVtex(orderFormId, userInformation)
    await setClientDataVtex(orderFormId, userInformation)
  }

  const saveShippingInformationVtex = async (addressObject) => {
    const { cms, orderFormId } = ecommerceInfo
    if (cms !== 'vtex' && cms !== 'vtex-io') return

    const { district, userAddress, price, region, aditionalInfo, deliveryType, courier, serviceType } = addressObject || addressInfo
    const street = userAddress.split(' ').slice(0, -1).join(' ')
    const number = userAddress.split(' ').pop()
    const codeRegion = regionCode[normalizeRegionName(region)]
    const newDistrict = setCitySelect(codeRegion, district)
    const postcode = ONLY_CHECKOUT.includes(companyInfo.companyName) ? getPostalCode(newDistrict) : getPinflagPostalCode(price)
    const addressInformation = {
      postalCode: postcode,
      state: DIFFERENT_REGION_NAME.includes(companyInfo.companyName) ? changedRegionName(region) : region,
      country: 'CHL',
      street,
      number,
      neighborhood: DIFFERENT_REGION_NAME.includes(companyInfo.companyName) ? newDistrict : district,
      complement: aditionalInfo,
      addressType: deliveryType,
      reference: `pinflag_${courier} - ${serviceType || ''}`,
      receiverName: userInfo.names,
      geoCoordinates: addressObject?.geoCoordinates
    }
    let logisticsInfo, response

    if (ONLY_CHECKOUT.includes(companyInfo.companyName)) {
      logisticsInfo = cartData.lines.map((_, index) => ({
        itemIndex: index,
        selectedDeliveryChannel: addressObject?.deliveryChannel || selectedServiceType.deliveryChannel,
        selectedSla: addressObject?.id || selectedServiceType.name
      }))
      response = await setShippingDataVtex(orderFormId, addressInformation, logisticsInfo)
      if (cms === 'vtex') {
        return window.parent.postMessage(
          {
            type: 'go-to-payment',
            origin: 'pinflag-checkout-iframe'
          },
          '*'
        )
      }
    } else {
      if (cms === 'vtex') {
        return window.parent.postMessage(
          {
            type: 'save-address-information',
            origin: 'pinflag-checkout-iframe',
            message: { addressInformation, orderFormId }
          },
          '*'
        )
      }
      response = await setShippingDataVtex(orderFormId, addressInformation)
    }
    console.log('response set shipping data', response.data)
    saveUserInformationVtex({ ...userInfo, names: userInfo.names.replace(' ', 'PINFLAG ') }, billingInfo)
  }

  const getSlasVtex = async (address, district, region, aditionalInfo, geoCoordinates) => {
    const { cms, orderFormId } = ecommerceInfo
    if (cms !== 'vtex' && cms !== 'vtex-io') return
    let street, number
    const codeRegion = regionCode[normalizeRegionName(region)]
    const newDistrict = district ? setCitySelect(codeRegion, district) : undefined
    const postcode = getPostalCode(newDistrict || region)
    if (address) {
      street = address.split(' ').slice(0, -1).join(' ')
      number = address.split(' ').pop()
    }
    const addressInformation = {
      postalCode: postcode,
      state: DIFFERENT_REGION_NAME.includes(companyInfo.companyName) ? changedRegionName(region) : region,
      country: 'CHL',
      street,
      number,
      neighborhood: DIFFERENT_REGION_NAME.includes(companyInfo.companyName) ? newDistrict : district,
      complement: aditionalInfo,
      addressType: 'search',
      receiverName: userInfo.names,
      geoCoordinates
    }
    const response = await setShippingDataVtex(orderFormId, addressInformation)
    return response.data
  }

  const getShippingInfoVtex = async (address, district, region, aditionalInfo, setDeliveryInfo, setIsLoading, handleConfirmation, setIsComplete) => {
    const response = await getSlasVtex(address, district, region, aditionalInfo)
    if (response.totalizers.length > 0) {
      const deliveryInfo = []
      try {
        const slas = response.shippingData.logisticsInfo[0].slas
        for (let i = 0; i < slas.length; i++) {
          if (slas[i].availableDeliveryWindows.length === 0) {
            const currentSla = {
              name: slas[i].id,
              description: parseDeliveryTime(slas[i].shippingEstimate),
              packageDeliveryTime: parseDeliveryTime(slas[i].shippingEstimate),
              price: getTotalPriceSLA(response.shippingData.logisticsInfo, i),
              serviceType: slas[i].id,
              deliveryChannel: slas[i].deliveryChannel
            }
            deliveryInfo.push(currentSla)
          }
        }
        setDeliveryInfo({ services: deliveryInfo })
        if (deliveryInfo.length === 1) handleConfirmation(deliveryInfo[0])
        setIsLoading(false)
      } catch (err) {
        removeIframeVTEX()
      }
    } else {
      removeIframeVTEX()
    }
    setIsComplete(true)
  }

  const getPickupPoints = async (addressObject, setIsLoading) => {
    const { address, district, region, aditionalInfo, geoCoordinates } = addressObject || searchAddress
    try {
      const deliveryInfo = await getSlasVtex(address, district, region, aditionalInfo, geoCoordinates)
      const pickupInfo = deliveryInfo.shippingData.logisticsInfo[0].slas.filter((point) => point.deliveryChannel === 'pickup-in-point')

      const mapPoints = pickupInfo.map((point) => {
        const currentPoint = deliveryInfo.shippingData.pickupPoints.filter((current) => current.id === point.pickupPointId)
        return (
          {
            geometry: { type: 'Point', coordinates: point.pickupStoreInfo.address.geoCoordinates },
            id: point.id,
            properties: {
              active: true,
              address: getFullAdress(point.pickupStoreInfo.address.street, point.pickupStoreInfo.address.number, point.pickupStoreInfo.address.complement),
              userAddress: getFullAdress(point.pickupStoreInfo.address.street, point.pickupStoreInfo.address.number, point.pickupStoreInfo.address.complement),
              company: companyInfo.companyName,
              deliveryTime: parseDeliveryTime(point.shippingEstimate),
              distance: point.pickupDistance,
              district: point.pickupStoreInfo.address.neighborhood,
              id: point.id,
              instructions: null,
              originalPrice: point.listPrice / 100,
              price: point.price / 100,
              region: normalizeRegionName(point.pickupStoreInfo.address.state),
              schedules: parseBusinessHoursVTEX(currentPoint[0].businessHours), // esto se saca de pickuppoints
              title: point.pickupStoreInfo.friendlyName,
              type: 'owned',
              deliveryChannel: point.deliveryChannel,
              deliveryType: 'search',
              geoCoordinates: point.pickupStoreInfo.address.geoCoordinates
            },
            type: 'Feature'
          }
        )
      })
      setPointsData((prevState) => {
        return {
          ...prevState,
          localPoints: mapPoints,
          pinflagPoints: []
        }
      })
      setIsLoading && setIsLoading(false)
      return mapPoints
    } catch (err) {
      setPointsData((prevState) => {
        return {
          ...prevState,
          localPoints: [],
          pinflagPoints: []
        }
      })
      setIsLoading && setIsLoading(false)
    }
  }

  const removeIframeVTEX = () => {
    window.parent.postMessage(
      {
        type: 'remove-iframe',
        origin: 'pinflag-checkout-iframe'
      },
      '*'
    )
  }

  return {
    setInitialInformationVtex,
    saveUserInformationVtex,
    saveShippingInformationVtex,
    iframeLoadedVtexIO,
    getShippingInfoVtex,
    getPickupPoints,
    removeIframeVTEX
  }
}
